"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _collapsible = _interopRequireDefault(require("../../../../collapsible"));
var _utils = require("../../../../../utils");
var _constant = require("../../../../../constant");
var _content = _interopRequireDefault(require("./content"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Details = function Details(_ref) {
  var opportunity = _ref.opportunity,
    open = _ref.open,
    onCollapse = _ref.onCollapse;
  return /*#__PURE__*/_react.default.createElement(_collapsible.default, {
    id: _constant.opportunitySection.DETAILS,
    title: "Details",
    onCollapse: onCollapse,
    open: open.details,
    showValidateIcon: false
  }, /*#__PURE__*/_react.default.createElement(_content.default, {
    opportunity: opportunity
  }));
};
Details.propTypes = {
  open: _utils.opportunitySectionsProps.isRequired,
  onCollapse: _propTypes.default.func.isRequired,
  opportunity: _utils.opportunityProps
};
Details.defaultProps = {
  opportunity: undefined
};
var _default = Details;
exports.default = _default;